'use client';

import type { LinkProps } from '../useLinkHooks';

export function useZoomHref({ href }: LinkProps) {
  return href;
}
